import React from 'react';
import { readInstallmentInputs, validateInstallmentFees } from '@/helpers/installmentFees';
import { updateMask } from '@/helpers/masks/cashNumber';
import { InputText } from '../InputText';
import { SelectCustom } from '../Select';

interface Props {
  name: string;
  value: string;
  onChange: (value: string) => void;
  error?: string | null;
  maxInstallments?: number;
  disabled?: boolean;
}

export const InstallmentFeesFields: React.FC<Props> = ({
  name,
  value,
  onChange,
  error,
  maxInstallments = 12,
  disabled = false,
}) => {
  const items = readInstallmentInputs(value);
  const count = Math.max(0, ...items.map(item => item.installment));
  return (
    <div className="mb-3">
      <SelectCustom
        name={name}
        disabled={disabled}
        label="Qtd parcelas"
        className="w-input-sm"
        value={String(count)}
        options={Array.from({ length: Math.max(maxInstallments, count) + 1 }, (_, index) => ({
          label: index === 0 ? 'Sem parcelas' : String(index),
          value: String(index),
        }))}
        onChange={option =>
          onChange(
            JSON.stringify(
              Array.from({ length: Number(option?.value ?? 0) }, (_, index) => ({
                installment: index + 1,
                fee: items.find(item => item.installment === index + 1)?.fee ?? updateMask('0'),
              })),
            ),
          )
        }
      />
      {items.map((item, index) => (
        <div className="d-flex mb-3" key={item.installment}>
          <InputText
            name={`${name}-${item.installment}-count`}
            label="Parcelas"
            addon="x"
            className="w-input-sm"
            value={String(item.installment)}
            disabled
            onChange={() => undefined}
          />
          <div className="ml-3">
            <InputText
              name={`${name}-${item.installment}-fee`}
              label="Juros ao mês"
              addon="%"
              className="w-input-sm"
              maxLength={5}
              value={item.fee}
              disabled={disabled}
              onChange={event =>
                onChange(
                  JSON.stringify(
                    items.map((row, ix) =>
                      ix === index
                        ? {
                            ...row,
                            fee: event.target.value.trim() ? updateMask(event.target.value) : '',
                          }
                        : row,
                    ),
                  ),
                )
              }
            />
          </div>
        </div>
      ))}
      {(error || validateInstallmentFees(value)) && (
        <span role="alert" className="alert-error">
          {error || validateInstallmentFees(value)}
        </span>
      )}
    </div>
  );
};
